import React, { useState } from 'react'
import { Button, Modal } from 'antd'
import PropTypes from 'prop-types'
import TestForm from './TestForm/TestForm'
import CompilationErrorAlert from '../../../../../../components/common/CompilationErrorAlert'

const TestModal = ({
    showModal,
    setShowModal,
    submitTest,
    modalTitle,
    submitButtonText,
    fields,
    setFramework,
    readOnly = false,
    errorMessage = '',
}) => {
    const [isWaitingForSubmitTest, setIsWaitingForSubmitTest] = useState(false)
    const [isWaitingForFixtureFilesUpload, setIsWaitingForFixtureFilesUpload] = useState(false)

    const handleCloseTestModal = () => {
        setShowModal(false)
    }

    const modalWidth = fields.testSuite ? 1200 : 600

    return (
        <Modal
            title={modalTitle}
            open={showModal}
            onCancel={handleCloseTestModal}
            footer={
                readOnly ? null : (
                    <>
                        <Button onClick={handleCloseTestModal}>Cancel</Button>
                        <Button
                            form='test-form'
                            htmlType='submit'
                            type='primary'
                            loading={isWaitingForSubmitTest}
                            disabled={isWaitingForFixtureFilesUpload}
                        >
                            {submitButtonText}
                        </Button>
                    </>
                )
            }
            width={modalWidth}
        >
            <TestForm
                setFramework={setFramework}
                fields={fields}
                submitTest={submitTest}
                onSuccessSubmit={() => setShowModal(false)}
                setIsWaitingForSubmitTest={setIsWaitingForSubmitTest}
                isWaitingForFixtureFilesUpload={isWaitingForFixtureFilesUpload}
                setIsWaitingForFixtureFilesUpload={setIsWaitingForFixtureFilesUpload}
            />
            <CompilationErrorAlert errorMessage={errorMessage} style={{ marginTop: 16 }} />
        </Modal>
    )
}

TestModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
    submitTest: PropTypes.func.isRequired,
    modalTitle: PropTypes.string,
    submitButtonText: PropTypes.string,
    errorMessage: PropTypes.string,
    fields: PropTypes.shape({
        name: PropTypes.bool,
        databaseDump: PropTypes.bool,
        input: PropTypes.bool,
        inputs: PropTypes.bool,
        functionName: PropTypes.bool,
        framework: PropTypes.bool,
        testSuite: PropTypes.bool,
        mainClassName: PropTypes.bool,
        cpuTimeLimit: PropTypes.bool,
        memoryLimit: PropTypes.bool,
        exactMatch: PropTypes.bool,
        ignoreCase: PropTypes.bool,
        fixtureFiles: PropTypes.bool,
    }),
}

export default TestModal
